import {ProductsApi} from "../../api/ProductsApi";
import {ApiError} from "../../api/http";
import {useAsync} from "../../components/useAsync";

// Public pages address products by SKU (the update check's links do), and the API by id: find it among the published ones.
export function usePublishedProduct(sku: string) {
    return useAsync(async () => {
        const products = await ProductsApi.getPublished();
        const product = products.find(x => x.sku.toLowerCase() === sku.toLowerCase());
        if (!product) {
            throw new ApiError(404);
        }
        return product;
    }, [sku]);
}
